// REACT & REDUX
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

// STYLE, PROPS & TRANSLATIONS
import { translate } from 'react-i18next';

// COMMON

// COMPONENTS
import { Root } from './Root.component';

// CONTAINERS

// ACTIONS & API

// *************************************************************************************************************************************

const mapStateToProps = state => {
    return (
        {
        });

};

export default connect(mapStateToProps)(Root);